<template>
  <div class="spellchecker-panel-content" :class="{'is-loading-or-empty': isLoadingOrEmptyState}">
    <aha-spinner v-if="isLoadingVisible" />

    <EmptyPanel v-if="isEmptyPanelVisible" />
    <ErrorPanel v-if="misspellFetchFailed" />

    <div
      class="panel__misspell-wrapper"
      v-show="isMisspellItemVisible"
    >
      <p class="py-3 mx-4 border-b border-base-30">
        {{ $i18nPresenter.t('Spelling') }}:
      </p>
      <div
        v-for="(misspell, misspellIndex) in misspells"
        :key="misspellIndex"
      >
        <MisspellItem :misspell="misspell" :misspellIndex="misspellIndex" />
      </div>
      <DismissAll />
    </div>

    <FakeDoorForm v-if="isFakeDoorFormVisible" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MisspellItem from '@/components-v2/presentation-editor/editor-header/quality-control/MisspellItem.vue'
import EmptyPanel from '@/components-v2/presentation-editor/editor-header/quality-control/EmptyPanel.vue'
import ErrorPanel from '@/components-v2/presentation-editor/editor-header/quality-control/ErrorPanel.vue'
import FakeDoorForm from '@/components-v2/presentation-editor/editor-header/quality-control/FakeDoorForm.vue'
import DismissAll from '@/components-v2/presentation-editor/editor-header/quality-control/DismissAll.vue'

export default {
  components: {
    MisspellItem,
    EmptyPanel,
    ErrorPanel,
    FakeDoorForm,
    DismissAll,
  },

  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    ...mapGetters('spellchecker', ['misspells', 'isFetchingMisspells', 'misspellFetchFailed', 'canUseSpellcheckerFakeDoorTest']),

    isLoadingOrEmptyState() {
      return this.isLoadingVisible || this.isEmptyPanelVisible
    },

    isEmptyPanelVisible() {
      return !this.misspellCount && !this.isFetchingMisspells && !this.misspellFetchFailed
    },

    isMisspellItemVisible() {
      return !this.isEmptyPanelVisible && this.misspellCount
    },

    misspellCount() {
      return this.misspells?.length || 0
    },

    isFakeDoorFormVisible() {
      return !this.isLoadingVisible && !this.isEmptyPanelVisible && this.canUseSpellcheckerFakeDoorTest
    },

    isLoadingVisible() {
      return this.isFetchingMisspells && !this.misspellCount
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.spellchecker-panel-content {
  @apply overflow-y-auto pt-0 relative;
  margin-top: $right-panel-header-height;
  padding-bottom: $right-panel-header-height;
  height: calc(100% - $right-panel-header-height);

  &.is-loading-or-empty {
    @apply flex h-full items-center justify-center;
  }
}
// .panel__misspell-wrapper:not(:last-child) {
//   &::after {
//     content: '';
//     width: calc(100% - 2rem);
//     height: 1px;
//     @apply bg-base-30 px-4 block my-0 mx-auto;
//   }
// }
</style>
